if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
      this.productForm = this.section?.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      this.variantPicker = this.section?.querySelector(`variant-picker[data-section="${this.sectionId}"]`);

      let lastY = 0;

      this.observer = new IntersectionObserver(([entry]) => {
        const currentY = entry.boundingClientRect.y;
        const scrollingDown = currentY < lastY;
        lastY = currentY;

        if (!entry.isIntersecting && scrollingDown) {
          this.classList.add('sticky-atc--active');
        } else {
          this.classList.remove('sticky-atc--active');
        }
      });

      if (this.productForm) {
        this.observer.observe(this.productForm);
      }

      this.addEventListener('click', async (event) => {
        const trigger = event.target.closest('[data-sticky-buy-now]');
        if (!trigger) return;

        event.preventDefault();

        if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;

        const form = this.productForm?.querySelector('form');
        if (!form) return;

        const totalEl = document.querySelector('[data-product-total-price]');
if (totalEl && form) {
  const qtyInput = form.querySelector('input[name="quantity"]');
  const quantity = qtyInput ? Math.max(1, Number(qtyInput.value || 1)) : 1;
  const unitPrice = Number(totalEl.dataset.unitPrice || 0);
  const moneyFormat = totalEl.dataset.moneyFormat || '₩{{amount}}';
  const amount = (unitPrice * quantity / 100).toLocaleString('ko-KR');
  totalEl.textContent = moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
}

        const idInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');

        const variantId = idInput ? idInput.value : '';
        const quantity = quantityInput ? Number(quantityInput.value) : 1;

        if (!variantId) return;

        trigger.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: quantity > 0 ? quantity : 1
                }
              ]
            })
          });

          if (!response.ok) {
            throw new Error('Sticky buy now add to cart failed');
          }

          window.location.href = '/checkout';
        } catch (error) {
          console.error(error);
        } finally {
          trigger.disabled = false;
        }
      });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}